<xux-progress-bar
  *ngIf="summaryList && summaryList.length > 0"
  [data]="progressBarData"
  [NoDataText]="NoDataText | translate"
  (hoverEvent)="handleHover($event)"
></xux-progress-bar>
<div class="stand-worksheet box-content">
  <ng-container *ngFor="let summary of summaryList">
    <div
      class="flex-item"
      (click)="gotoStandWorksheetPage(summary.status)"
      [ngClass]="{ hovered: summary.isHovered }"
    >
      <div class="label-text">
        {{ summary.text }}<span class="num">{{ summary.count }}</span>
      </div>
      <img src="{{ 'assets/img/right.png' | xviSourcePath }}" />
    </div>
  </ng-container>
</div>
